import React from 'react';
import MagicBackground from '../../background/MagicBackground';
import HappyBackground from '../../background/themes/HappyBackground';
import BarnyardBackground from '../../background/themes/BarnyardBackground';
import OceanBackground from '../../background/themes/OceanBackground';
import JungleBackground from '../../background/themes/JungleBackground';
import FoodBackground from '../../background/themes/FoodBackground';
import MysticalBackground from '../../background/themes/MysticalBackground';
import DemoTapBackground from '../../background/demo/DemoTapBackground';
import { EmojiTheme } from '../../utils/types';

interface GameBackgroundProps {
  isPlaying: boolean;
  gameStatus: 'playing' | 'won' | 'lost' | 'idle' | 'expired';
  currentTheme?: EmojiTheme; // Theme-based background styling
}

const GameBackground: React.FC<GameBackgroundProps> = ({ isPlaying, gameStatus, currentTheme }) => {
  // Render theme-specific background based on theme name
  const renderThemeBackground = () => {
    if (!currentTheme) return <MagicBackground />; // Default fallback
    
    switch (currentTheme.name) {
      case "Happy Rescue":
        return <HappyBackground />;
      case "Barnyard Rescue":
        return <BarnyardBackground />;
      case "Ocean Rescue":
        return <OceanBackground />;
      case "Jungle Rescue":
        return <JungleBackground />;
      case "Travel Rescue":
        return <MagicBackground />; // Keep current cosmic background
      case "Food Rescue":
        return <FoodBackground />;
      case "Rare Creatures":
        return <MysticalBackground />;
      default:
        return <MagicBackground />; // Fallback
    }
  };

  return (
    <>
      {renderThemeBackground()}
      {gameStatus === 'idle' && <DemoTapBackground />}
    </>
  );
};

export default GameBackground; 